/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    DOMAIN_NOTIFY_LIST_SUCCESS,
    DOMAIN_CREATE_NOTIFY_SUCCESS,
    DOMAIN_NOTIFY_DETAIL_SUCCESS,
    DOMAIN_NOTIFY_EDIT_SUCCESS
} from "../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const DomainNotifiesReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case DOMAIN_NOTIFY_LIST_SUCCESS:
            let notifies = action.payload.data.data;

            notifies.map((notify) => {
                let id = notify['_id'];
                state[id] = notify;
                return true;
            });

            return {...state, action};

        case DOMAIN_NOTIFY_EDIT_SUCCESS:
        case DOMAIN_NOTIFY_DETAIL_SUCCESS:
        case DOMAIN_CREATE_NOTIFY_SUCCESS:
            let id = action.payload.data['id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {DomainNotifiesReducer}